module.exports = __webpack_public_path__ + "static/media/logo-15@2x.fd91c43e.png";